import { waitForPageLoadAnalytics } from "../pageLoad";
import getWindow from "../../utils/window";
import { getCommons, getGlobalEvars } from "../common";
import { setEvents, setLinkTrackEvents } from "../events";

let hasFired = false;

export const resetWaysToStyleScrollToView = () => {
  hasFired = false;
};

export const fireWaysToStyleScrollToView = async () => {
  if (hasFired) {
    return;
  }

  hasFired = true;

  await waitForPageLoadAnalytics;

  const s = getWindow().s;
  const commons = getCommons();
  const TRACKING_NAME = "waysToStyleCtaView";

  setEvents({
    events: ["event172"],
    trackingName: TRACKING_NAME,
  });

  s.eVar106 = "btl|CTA|impression";

  s.tl(true, "o", "btl cta impression", {
    linkTrackVars: commons.setLinkTrackVars([...getGlobalEvars(), "eVar106"]),
    linkTrackEvents: setLinkTrackEvents({
      trackingName: TRACKING_NAME,
    }),
  });
};
